import { type FC } from 'react';
import CheckShield from 'dibs-icons/exports/CheckShield.ts';
import MoneyBackGuarantee from 'dibs-icons/exports/MoneyBackGuarantee.ts';
import Cancellation24Hours from 'dibs-icons/exports/Cancellation24Hours.ts';
import Storefront from 'dibs-icons/exports/Storefront.ts';
import PriceParity from 'dibs-icons/exports/PriceParity.ts';
import Delivery from 'dibs-icons/exports/Delivery.ts';

import { type BuyerIncentiveName } from './hooks/useBuyerIncentivesList.ts';

const BuyerIncentiveIcon: FC<{ name: BuyerIncentiveName; size: '20' | '24' }> = ({
    name,
    size,
}) => {
    switch (name) {
        case 'authenticityGuarantee':
            return <CheckShield variation={size} />;
        case 'moneyBackGuarantee':
            return <MoneyBackGuarantee variation={size} />;
        case 'cancelationPolicy':
            return <Cancellation24Hours variation={size} />;
        case 'vettedSellers':
            return <Storefront variation={size} />;
        case 'priceMatch':
            return <PriceParity variation={size} />;
        case 'globalDelivery':
            return <Delivery variation={size} />;
        default:
            return null;
    }
};

export default BuyerIncentiveIcon;
